import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";

const DemoCtaSection = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ days: 29, hours: 22, minutes: 59, seconds: 57 });

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prev) => {
        let { days, hours, minutes, seconds } = prev;
        seconds--;
        if (seconds < 0) { seconds = 59; minutes--; }
        if (minutes < 0) { minutes = 59; hours--; }
        if (hours < 0) { hours = 23; days--; }
        if (days < 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        return { days, hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const timeBlocks = [
    { value: time.days, label: "Days" },
    { value: time.hours, label: "Hours" },
    { value: time.minutes, label: "Minutes" },
    { value: time.seconds, label: "Seconds" },
  ];

  return (
    <section id="demo" className="py-24">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <div className="animate-fade-in">
          <h2 className="text-3xl font-bold md:text-5xl">30 DAYS FREE</h2>
          <p className="mt-2 text-lg font-semibold tracking-wider text-primary">NO CREDIT CARD REQUIRED</p>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Experience the full SecureFlex platform free for 30 days. All features included — unlimited check-ins, live GPS tracking, biometric verification, and AI incident analysis.
          </p>
          <div className="mt-10 flex justify-center gap-4">
            {timeBlocks.map((b) => (
              <div key={b.label} className="rounded-xl border border-border bg-card px-3 py-3 sm:px-5 sm:py-4">
                <p className="text-2xl font-bold text-primary sm:text-3xl md:text-4xl">{String(b.value).padStart(2, "0")}</p>
                <p className="mt-1 text-xs text-muted-foreground">{b.label}</p>
              </div>
            ))}
          </div>
          <Button size="lg" className="mt-10 gap-2 rounded-full text-base" onClick={() => navigate("/app/signup")}>Start Your Free 30-Day Trial</Button>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            {["Full GPS Live Map", "Biometric Check-in", "AI Incident Analysis", "No Setup Fee", "No Credit Card"].map((b) => (
              <Badge key={b} variant="secondary" className="rounded-full px-4 py-1.5">{b}</Badge>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoCtaSection;
